import { useMutation } from "@tanstack/react-query";
import { useNotification } from "../../components/common/GlobalNotification";
import { FilterGroup } from "./baseDto";

const downloadBlob = (blob: Blob, filename: string): void => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const useExport = (
  exportFn: (filterGroup: FilterGroup) => Promise<Blob>,
  filename: string,
  errorMessage: string,
) => {
  const { setSuccessNotification, setErrorNotification } = useNotification();

  return useMutation({
    mutationFn: async (filterGroup: FilterGroup): Promise<Blob> =>
      exportFn(filterGroup),
    onSuccess: (blob) => {
      downloadBlob(blob, filename);
      setSuccessNotification("Exported successfully");
    },
    onError: () => {
      setErrorNotification(errorMessage);
    },
  });
};
